
import React from 'react';
import { Check, Database, LineChart, Users, Bot, Award, FileSpreadsheet } from 'lucide-react';

const MethodologySection = () => {
  return (
    <section className="py-16 md:py-24 bg-secondary/10">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16 reveal">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6">
            Our Proven Data Adoption Methodology
          </h2>
          <p className="text-lg text-muted-foreground">
            The Stratodata Data-Driven Adoption Framework provides a systematic approach to building and implementing 
            a successful data strategy tailored to your specific business needs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {stages.map((stage, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 shadow-sm border border-border reveal"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                {stage.icon}
              </div>
              <h3 className="text-lg font-semibold mb-2">{stage.title}</h3>
              <p className="text-muted-foreground text-sm mb-4">{stage.description}</p>
              <ul className="space-y-2">
                {stage.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <Check className="h-4 w-4 text-primary mr-2 mt-1 flex-shrink-0" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="text-center reveal">
          <a href="/tell-me-more" className="btn-secondary inline-flex items-center">
            Talk to a Data Strategy Expert
          </a>
        </div>
      </div>
    </section>
  );
};

const stages = [
  {
    icon: <FileSpreadsheet className="h-6 w-6 text-primary" />,
    title: "Use Cases Collection",
    description: "We identify your most valuable data opportunities",
    features: [
      "Business KPI alignment",
      "Value assessment",
      "Prioritization framework",
      "Stakeholder interviews"
    ]
  },
  {
    icon: <Database className="h-6 w-6 text-primary" />,
    title: "Source Systems Integration",
    description: "Connect and standardize your data sources",
    features: [
      "Data source mapping",
      "ETL/ELT pipeline setup",
      "Data quality validation",
      "Integration architecture"
    ]
  },
  {
    icon: <LineChart className="h-6 w-6 text-primary" />,
    title: "Reporting Deployment",
    description: "Create actionable reports and dashboards",
    features: [
      "Custom dashboard creation",
      "Data visualization design",
      "Automated reporting",
      "Self-service analytics tools"
    ]
  },
  {
    icon: <Users className="h-6 w-6 text-primary" />,
    title: "Data Champion Program",
    description: "Build internal data capability and culture",
    features: [
      "Champion identification",
      "Training workshops",
      "Knowledge transfer",
      "Community of practice"
    ]
  },
  {
    icon: <Award className="h-6 w-6 text-primary" />,
    title: "Reporting Adoption",
    description: "Ensure solutions deliver real business value",
    features: [
      "User onboarding",
      "Adoption tracking",
      "Feedback collection",
      "Continuous improvement"
    ]
  },
  {
    icon: <Bot className="h-6 w-6 text-primary" />,
    title: "Automation & AI Integration",
    description: "Enhance operations with intelligent automation",
    features: [
      "Process automation",
      "AI-powered insights",
      "Predictive analytics",
      "Decision support systems"
    ]
  }
];

export default MethodologySection;
